<template>
  <div>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="fullPage" :opacity="1"></loading>
    <menu-superior titulo="PESQUISAR" id="menusuperior-pesquisa"></menu-superior>
    <div class="container">
      <form>
        <div class="row">
          <div class="input-field col s10">
            <i class="material-icons prefix">search</i>
            <textarea id="icon_prefix2" class="materialize-textarea" :value='termoBusca'
                      @input='evt=>termoBusca=evt.target.value' v-on:keyup="Pesquisar"></textarea>
            <label for="icon_prefix2">Pesquisar</label>
          </div>
          <div class="col s2" style="padding: 19px 0rem 0 0;" @click="Pesquisar()">
            <a class="waves-effect waves-light btn-small"
               :style="'background-color: '+this.$store.state.empresa.cor_primaria"><span style="font-weight: 700"><i
              class="material-icons">search</i></span></a>
          </div>
        </div>
      </form>
    </div>
    <div class="container page-section">
      <div class="row">
        <card v-for="produto in produtosFiltro" :produto="produto" :key="'itempromocaoa-'+produto.id" :id="produto.id"></card>
      </div>
    </div>
  </div>
</template>

<script>
import MenuSuperior from "./template/MenuSuperior.vue";
import TituloDestacado from "./template/TituloDestacado.vue";
import Card from "../components/Card.vue";
import SecureLS from "secure-ls";
import ProdutosContainerFlex from "../components/ProdutosContainerFlex.vue";
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "Pesquisa",
  data() {
    return {
      grupos: [],
      produtos: [],
      produtosFiltro: [],
      termoBusca: '',
      isLoading: false,
      fullPage: true,
    }
  },
  components: {ProdutosContainerFlex, Card, TituloDestacado, MenuSuperior, Loading},
  mounted() {

    if (this.$route.query.produto) {
      this.isLoading = true;
    }

    var ls = new SecureLS();
    var itens = ls.get('gruposSecoesPromocoes');
    var produtos = [];

    let grupos = [];
    $.each(itens.grupos, function (key, value) {
      grupos.push(value);
    });

    grupos.forEach(res => {
      $.each(res.secoes, function (key, value) {
        $.each(value.itens, function (key, value) {
          produtos.push(value);
        });
      });
    });
    this.produtos = produtos;
    this.produtosFiltro = produtos;

    var elmnt = document.getElementById('menusuperior-pesquisa');
    elmnt.scrollIntoView(true);
    window.scrollBy(0, -0);

  },
  updated() {
    try {
      setTimeout(() => {
        if (this.$route.query.produto) {
          const produto = this.$route.query.produto;

          let retryCount = parseInt(localStorage.getItem("retryCount")) || 0;
          const maxRetries = 5;

          const divElement = document.getElementById(produto);
          if (divElement) {
            localStorage.removeItem("retryCount");
            this.$router.replace("/" + this.$store.state.empresa_url + "/menu");
            divElement.click();
          } else {
            retryCount++;
            if (retryCount >= maxRetries) {
              alert("Produto não localizado :(");
              localStorage.removeItem("retryCount");
              this.$router.push("/" + this.$store.state.empresa_url + "/menu");
            } else {
              localStorage.setItem("retryCount", retryCount);
              this.$router.push("/" + this.$store.state.empresa_url + "/menu?produto=" + produto);
            }
          }
        }
      }, 500);
    } catch (exception) {
      console.error(exception);
    }
  },
  methods: {
    Pesquisar() {
      this.produtosFiltro = _.filter(this.produtos, res => {
        var termo = this.termoBusca.toUpperCase();
        return res.nome.toUpperCase().indexOf("" + termo + '') > -1;
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/views/Pesquisa.vue